import { useState, useEffect, useRef, useMemo } from 'react'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import { setStorageLng } from './../../i18n/storage'
import './index.less'
import type { MenuProps } from 'antd';
import { Button, Dropdown, Space, message } from 'antd';
import { i18n_langs } from '@/i18n/config';
import ConnectBtn from './../ConnectButton';
import { toggleSide } from '@/stores/actions';
import SettingPop from '../SettingPop';
import PriorityFeeContent from './PriorityFeeContent';
import NetWorkButton from './NetWorkButton';
import { cdnUrl } from '@/utils/cdn';
import { getChainsResource } from '@/utils/methods';
import { ConnectButton } from '@mysten/dapp-kit';
import { FuPrivider } from '@/provider/FuProvider';
const { urlSuffix }: any = getChainsResource();

export default function NavInner() {
  let location = useLocation();
  const { t, i18n } = useTranslation();
  // console.log("i18n", i18n.language);
  const dispatch = useDispatch()
  const cache = useRef<any>(false)
  const [balance, setBalance] = useState<number>(0);
  const [accountTmp, setAccountTmp] = useState<any>('');
  const { isM, is1920, is1440, is1200, is750 } = useSelector((state: any) => {
    return state.device
  })
  const navigate = useNavigate()
  const params = useParams();
  const currentLang = params.lang; // 假设你的路由路径定义中包含 `:lang`
  const [collapsed, setCollapsed] = useState(false);
  const [open, setOpen] = useState(false);
  const [showLang, setShowLang] = useState(false);
  const [selectedKeys, setSelectedKeys] = useState([])
  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };


  const switchToLang = (lang: string) => {
    return location.pathname.replace(`/${currentLang}`, `/${lang}`) + location.search;
  };
  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng); // 更改 i18n 的语言
    const currentPath = location.pathname;
    let newPath = "";
    if (currentPath === "/") {
      newPath = `/${lng}`;
    } else {
      const clean = currentPath.toLowerCase().replace(/^\/+/, '');
      const segments = clean.split('/');
      const firstSegment = segments[0];
      if (i18n_langs.includes(firstSegment)) {
        newPath = currentPath.replace(/^\/[^\/]+/, `/${lng}`);
      } else {
        newPath = `/${lng}` + currentPath;
      }
    }
    setStorageLng(lng)
    // console.log("newPath", currentPath,newPath);
    navigate(newPath, { replace: true }); // 导航到新的地址，不添加历史记录
  };

  function onBack() {
    navigate('/')
  }

  const items: MenuProps['items'] = [
    {
      key: 'zh-cn',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('zh-cn')
        }}>
          <div><img src={cdnUrl("/img/lang/ZH.svg")} alt="lang" /> 中文简体 - ZH </div> {'zh-cn' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'zh-hk',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('zh-hk')
        }}>
          <div><img src={cdnUrl("/img/lang/HK.svg")} alt="lang" />  中文繁體 — HK</div>{'zh-hk' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'en-us',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('en-us')
        }}>
          <div><img src={cdnUrl("/img/lang/EN.svg")} alt="lang" />  English - EN</div> {'en-us' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'ru-ru',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('ru-ru')
        }}>
          <div><img src={cdnUrl("/img/lang/RU.svg")} alt="lang" />  Русский - RU </div>{'ru-ru' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    }, {
      key: 'tr-tr',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('tr-tr')
        }}>
          <div><img src={cdnUrl("/img/lang/TR.svg")} alt="lang" />  Türkçe - TR </div>{'tr-tr' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'ja-jp',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('ja-jp')
        }}>
          <div><img src={cdnUrl("/img/lang/JA.svg")} alt="lang" />  日本語 - JA </div>{'ja-jp' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'fr-fr',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('fr-fr')
        }}>
          <div><img src={cdnUrl("/img/lang/FR.svg")} alt="lang" />  Français - FR </div>{'fr-fr' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'de-de',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('de-de')
        }}>
          <div><img src={cdnUrl("/img/lang/DE.svg")} alt="lang" />  Deutsch - DE </div>{'de-de' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'es-es',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('es-es')
        }}>
          <div><img src={cdnUrl("/img/lang/ES.svg")} alt="lang" />  Español - ES </div>{'es-es' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'hi',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('hi')
        }}>
          <div><img src={cdnUrl("/img/lang/HI.svg")} alt="lang" />  हिंदी — HI </div>{'hi' === i18n.language ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'vi-vi',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('vi-vi')
        }}>
          <div><img src={cdnUrl("/img/lang/VI.svg")} alt="lang" />  Tiếng Việt — VI </div>{'vi-vi' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'ko-kr',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('ko-kr')
        }}>
          <div><img src={cdnUrl("/img/lang/KO.svg")} alt="lang" />  한국어 — KO </div>{'ko-kr' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
    {
      key: 'pl-pl',
      label: (
        <div className='lang-child' onClick={() => {
          changeLanguage('pl-pl')
        }}>
          <div><img src={cdnUrl("/img/lang/PL.svg")} alt="lang" />  Polski — PL </div>{'pl-pl' === i18n.language?.toLowerCase() ? <img src={cdnUrl("/img/eth/current-lang.svg")} alt="" /> : null}
        </div>
      ),
    },
  ];

  const userItems: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div onClick={() => {

        }}>{t('menu.BALANCE')}</div>
      ),
    },
  ];

  function toggleLang() {
    setShowLang(!showLang)
  }

  const showDrawer = () => {

    dispatch(toggleSide({
      show: true
    }))
  };

  useEffect(() => {
    document.addEventListener('click', e => {
      setShowLang(false)
    })
  }, [])

  function renderLang() {
    return (
      <div className='lang-box'>
        <div className='lang-btn' onClick={() => {
          changeLanguage('zh-cn')
        }}>中文简体</div>
        <div className='lang-btn' onClick={() => {
          changeLanguage('en-us')
        }}>EN</div>
      </div>
    )
  }

  function showMore() {
    message.info(t('tips.wait'))
  }


  return (
    <div className="nav-inner">
      <div className='nav-inner__main'>
        {/* {
          isM && (<Link to={`/${urlSuffix}`} className='logo'>
            <img src={cdnUrl("/img/slerf/750/logo.svg")} alt="" />
          </Link>)
        } */}
      </div>


      <div className='nav-inner__sub'>
        <div className='lang'>
          <Dropdown menu={{ items }} placement="bottom" overlayClassName="cus-drop-menu">
            <button className='language-box'>
              {
                !isM && <span className="text">Language/语言</span>
              }

              <img src={cdnUrl("/img/eth/lang.svg")} alt="" />
              <div className="lang-code">{i18n.language ? i18n.language.slice(0, 2).toUpperCase() : ''}</div>
            </button>
          </Dropdown>
          {
            showLang && renderLang()
          }
        </div>
        <NetWorkButton />
        {/* {
        (!isM && !is750) && <PriorityFeeButton />
      } */}

        {/* <SettingPop>
          <PriorityFeeContent />
        </SettingPop> */}

        {/* style={{
          display: 'inline-flex',
          height: 32,
          overflow: 'hidden',
          boxShadow: '0 0 12px rgba(0,0,0,0.15)',
          borderRadius: "20px"
        }} */}
        {/* <ConnectBtn /> */}
        <div style={{
          display: 'inline-flex',
          height: "32px",
          overflow: 'hidden',
          // boxShadow: '0 0 12px rgba(0,0,0,0.15)';
          borderRadius: "20px",

        }}
        >
          <ConnectButton></ConnectButton>
          {/* <FuPrivider></FuPrivider> */}
        </div>

        {
          isM && (<button className='more' onClick={showDrawer}>
            <img src={cdnUrl("/img/slerf/750/menu.svg")} alt="" />
          </button>)
        }
        {/* {
          isM && (
            <Dropdown menu={ {items: userItems} } placement="bottomLeft" overlayClassName="cus-drop-menu">
              <button className='more'>
                <img src={cdnUrl("/img/mob/more.png")} alt="" />
              </button>
            </Dropdown>
          )
        } */}
      </div>
    </div >)
}